export const DEPT_REPORT_TYPE = [
  {
    key: "Target",
    value: "Target"
  },
  {
    key: "Checkin",
    value: "Check-Ins"
  }
];

export const SUCCESS_STORY_TYPE = [
  {
    key: "TeamSuccessStories",
    value: "Team Success Stories"
  },
  {
    key: "MySuccessStories",
    value: "My Success Stories"
  }
];

export const CHECKIN_TYPE = {
  LEARNING: "Learning",
  REQUESTFEEDBACK: "Request feedback",
  SURVEY: "Survey",
  EVENT: "Event",
  GENERAL: "General",
  TEXT: "Text",
  DOCUMENT: "Document",
  VIDEO: "Video",
  IMAGE: "Image",
  AUDIO: "Audio",
  MULTIMEDIA: "Multimedia",
  LINK: "Link",
  TEST: "Test",
  SKILLRATING: "Skill rating",
  ONLINE: "Online",
  INPERSON: "In Person"
};
export const CHECKIN_TYPE_COLOR = {
  SURVEY: "#120078",
  EVENT: "#075446",
  GENERAL: "#416CE3"
};
export const targetDistributionColumn = [
  "Target Types",
  "No. of Targets",
  "Departments",
  "Active",
  "Completed",
  "Incomplete",
  "Paused"
];

export const checkinDistributionColumn = [
  "Check-In Types",
  "No. of Check-Ins",
  "Department",
  "Active",
  "Completed",
  "Overdue",
  "Post-Target"
];

export const TARGET_CHECKIN_TABS = [
  {
    key: "Target",
    text: "Target"
  },
  {
    key: "CheckIn",
    text: "Check-Ins"
  }
];

export const LOGOURL =
  "https://ialignemailtemplateimages.s3.amazonaws.com/logo-black.png";
